import {Spin} from "antd";
import {LoadingOutlined} from "@ant-design/icons";
import ContainerComponent from "../../../helpers/components/container.component";
import PageHeaderComponent from "../../../helpers/components/page_header.component";
import globalHelper from "../../../helpers/functions/global.helper";
import React, {useState} from "react";

const MerchantSettlementDetail = (props) => {

    const {activity} = props;
    const [state, setState] = useState({
        loading: false,
    });
    return (
        <>
            <Spin spinning={state?.loading} indicator={<LoadingOutlined/>}>
                <div style={{textAlign: 'start', marginBottom: 20,}}>
                    <div className='title-header mobile-padding-24'>
                        <ContainerComponent span={20}>
                            <PageHeaderComponent title={'Activity Details - Merchant Settlement'} textAlign={'start'}/>
                        </ContainerComponent>
                    </div>
                    <div
                        className='mobile-padding-24'
                        {...!globalHelper?.isMobileScreen() && ({style: {marginTop: 24,}})}
                    >
                        <ContainerComponent span={20}>
                            <div style={{ padding: '24px' }}>
                                <h2 style={{ marginBottom: '20px' }}>Activity Details</h2>

                                <div style={{
                                    display: 'grid',
                                    gridTemplateColumns: '200px 1fr',
                                    rowGap: '12px',
                                    columnGap: '16px'
                                }}>
                                    <div><strong>Transaction No:</strong></div>
                                    <div>{activity?.transaction_no || '-'}</div>

                                    <div><strong>Transaction Type:</strong></div>
                                    <div>{activity?.transaction_type?.name || '-'}</div>

                                    <div><strong>Merchant Name:</strong></div>
                                    <div>{activity?.from_wallet?.merchant?.name || '-'}</div>


                                    <div><strong>Wallet ID:</strong></div>
                                    <div>{activity?.from_wallet?.name ?? '-'}</div>

                                    <div><strong>Created At:</strong></div>
                                    <div>{activity?.created_at ? new Date(activity.created_at).toLocaleString() : '-'}</div>

                                    <div><strong>Melon Amount:</strong></div>
                                    <div>{activity?.melon_amount ?? '-'}</div>

                                    <div><strong>Payment Amount:</strong></div>
                                    <div>
                                        {activity?.merchant_settlement?.payment_amount != null
                                            ? `${activity.merchant_settlement?.currency?.code || ''}${activity.merchant_settlement.payment_amount}`
                                            : '-'}
                                    </div>

                                    {/* Add more fields as needed */}
                                </div>
                            </div>
                        </ContainerComponent>

                    </div>
                </div>
            </Spin>
        </>
    );
};

export default MerchantSettlementDetail;